import { render } from "./Rules.vue?vue&type=template&id=ae8b60ee&scoped=true&ts=true"
import script from "./Rules.vue?vue&type=script&lang=ts"
export * from "./Rules.vue?vue&type=script&lang=ts"

import "./Rules.vue?vue&type=style&index=0&id=ae8b60ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8b60ee"]])

export default __exports__